import React, { useEffect, useState } from 'react'
import { Card, Col, Row, Container, Image } from 'react-bootstrap';
import { BiTimeFive } from 'react-icons/bi';
import { BsFillShareFill } from 'react-icons/bs';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getList, post } from '../helpers/api_helper';
import Loader from '../components/Loader/Loader';

function OpportunitieList(props) {
    const [joblist, setJoblist] = useState([]);
    const [full, setFull] = useState(false);
    const [filter, setFilter] = useState({});
    const [loader, setLoader] = useState(true);
    const { user } = props;
    // console.log('props all data', props?.history?.location?.state?.state)


    useEffect(() => {
        getListingjob();
    }, [filter]);

    useEffect(() => {
        if (props?.for)
            setFull(props?.for);
        if (props?.history?.location?.state?.state) {
            if (props?.history?.location?.state?.state?.indId)
                setFilter({ ...filter, indId: props?.history?.location?.state?.state?.indId })
            if (props?.history?.location?.state?.state?.city)
                setFilter({ ...filter, city: props?.history?.location?.state?.state?.city })
        }

    }, [props])

    const getListingjob = () => {
        setLoader(true);
        let url = '/oppor/list';
        if (filter?.indId)
            url = url + '?industryId=' + filter?.indId
        if (filter?.city)
            url = url + '?city=' + filter?.city
        getList(url).then((json) => {
            if (json.statusCode == 200) {
                setLoader(false);
                setJoblist(json);
                // console.log('oppolist', json)
            } else {
                setLoader(false);
            }

        })

    }

    const routerFunction = (item) => {
        let title = item?.title.toLowerCase();
        props.history.push("/opportunity/" + item?._id + "/" + title.split(" ").join("_"));
        // localStorage.setItem('opprtunity', path);
        // console.log('item ', item)
    }

    const applyFunction = (item) => {
        // console.log('user',user);
        const id = item?._id;
        let title = item?.title.toLowerCase();
        let path = title.split(" ").join("_") + "_" + item?._id;
        if (user) {
            const body = {
                opporId: id,
                userId: user?._id,
                token: user?.token
            }
            post('/oppor/apply', body).then((json) => {

                if (json.statusCode == 200) {
                    toast.success(json.message);
                    getListingjob();
                }

            })
                .catch((error => {
                    toast.error(error);
                }))
        } else {
            props.history.push('/login');
            localStorage.setItem('opprtunity', path);
        }

    }

    // console.log('data opportunities', joblist);

    return (
        <>
            {loader && <Loader />}
            <Container>
                <Row>
                    {
                        joblist.data?.map((item, i) =>
                            full ?
                                <Col lg={12} md={6} sm={6} key={item?._id}>
                                    <Card className='opportunities_box'>
                                        <Row>
                                            <Col lg={1} md={12} className="job_box_d">
                                                <div className='company_logo'>
                                                    <Image src={item?.company[0]?.logo} />
                                                </div>
                                            </Col>
                                            <Col lg={7} md={12} className="job_box_d">
                                                <div className='job-title'>
                                                    <h4>{item?.title}</h4>
                                                    <h6>{item?.company[0]?.title}</h6>

                                                    <p>Position <span className='span-color1'>({item?.vacancy})</span> Location <span className='span-color'>({item?.location?.length})</span> <span><BiTimeFive /> {item?.createdAt}</span></p>
                                                </div>
                                            </Col>
                                            <Col lg={4} md={12} className="job_box_d job_box_d_position">
                                                <div className='action-box'>
                                                    <ul>
                                                        <li>
                                                            {
                                                                item.applicant.findIndex(x => x.userId == user?._id) == -1 ? <a onClick={() => applyFunction(item)}>Apply Now</a> : <a >Applied</a>
                                                            }
                                                        </li>
                                                        <li><a onClick={() => routerFunction(item)}>View</a></li>
                                                        <li>
                                                            <a href='#'><BsFillShareFill /></a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </Col>
                                        </Row>

                                    </Card>
                                </Col>
                                :
                                <>
                                    {i < 5 &&
                                        <Col lg={12} md={6} sm={6}>
                                            <Card className='opportunities_box'>
                                                <Row>
                                                    {/* <Col lg={1} md={12} className="job_box_d">
                                                        <div className='company_logo'>
                                                            <Image src={item?.company[0]?.logo} />
                                                        </div>
                                                    </Col> */}
                                                    <Col lg={8} md={12} className="job_box_d">
                                                        <div className='job-title'>
                                                            <h4>{item?.title}</h4>
                                                            <h6>{item?.company[0]?.title}</h6>

                                                            <p>Position <span className='span-color1'>({item?.vacancy})</span> Location <span className='span-color'>({item?.location?.length})</span> <span><BiTimeFive /> {item?.createdAt}</span></p>
                                                        </div>
                                                    </Col>
                                                    <Col lg={4} md={12} className="job_box_d job_box_d_position">
                                                        <div className='action-box'>
                                                            <ul>
                                                                <li>
                                                                    {
                                                                        item.applicant.findIndex(x => x.userId == user?._id) == -1 ? <a onClick={() => applyFunction(item)}>Apply Now</a> : <a >Applied</a>
                                                                    }
                                                                </li>
                                                                <li><a onClick={() => routerFunction(item)}>View</a></li>
                                                                <li>
                                                                    <a href='#'><BsFillShareFill /></a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </Col>
                                                </Row>

                                            </Card>
                                        </Col>
                                    }
                                </>
                        )
                    }

                </Row>


                {
                    !full && <Col className="text-center pt_20px">
                        <Link to="/job-listing" className='kn_btn view_m_btn' style={{ border: '1px solid #222752' }}>View More</Link>
                    </Col>
                }
            </Container>
        </>
    )
}

const mapStateToProps = state => {
    // console.log('apply', state)
    const { user } = state.Login
    return { user }
}

export default withRouter(
    connect(mapStateToProps, {})(OpportunitieList)
)